import { PublicEducator } from '@cademy-package/sdk-component-types';
import { FunctionComponent, ReactElement, useMemo } from 'react';
import { Enrolments } from '../../../../pages_components/[educator_param]/[course_param]/useEnrolments';
import styles from './styles.module.scss';
import { BadgePercentLightIcon } from '../../../Icons';

type SubscriptionBenefitsBadgesProps = {
    educator: PublicEducator;
    subscriptionBenefits: Enrolments['subscriptionBenefits'];
};

export const SubscriptionBenefitsBadges: FunctionComponent<SubscriptionBenefitsBadgesProps> = ({
    educator,
    subscriptionBenefits,
}) => {
    const subscriptionBadges = useMemo(() => {
        if (!subscriptionBenefits) {
            return [];
        }

        let badges: ReactElement[] = [];

        if (subscriptionBenefits.freeEntry) {
            badges.push(
                <span key="freeEntry" className={styles.badge}>
                    <BadgePercentLightIcon />
                    Free With Your Membership
                </span>
            );
        }

        if (subscriptionBenefits.discountedEntry) {
            badges.push(
                <span key="discountedEntry" className={styles.badge}>
                    <BadgePercentLightIcon />
                    {subscriptionBenefits.discountedEntry}% Off With Your Membership
                </span>
            );
        }

        return badges;
    }, [subscriptionBenefits]);

    if (educator.feature_flags?.hide_pricing) {
        return null;
    }
    if (subscriptionBadges.length === 0) {
        return null;
    }

    return <div className={styles.subscriptionBadges}>{subscriptionBadges}</div>;
};
